// useRequestInitialValues.js
import { useMemo } from "react";

export const useRequestInitialValues = ({
  id,
  requestById,
  reference,
  user,
  contactId,
}) => {
  return useMemo(() => {
    const req = requestById || {};

    return {
      id: id ? req._id || "" : "",
      department: req.department || "",
      requestReference: id ? req.requestReference || "" : reference || "",
      requestContact: req.requestContact?._id || contactId || "",
      requestConsultant: req.requestConsultant?._id || user?._id || "",
      requestAdType: req.requestAdType || [],
      requestComment: req.requestComment || "",
      requestBuildingType: req.requestBuildingType || [],
      requestZone: [],

      // Precios
      salePriceMax:
        req.requestSalePrice?.salePriceMax === 999999999
          ? ""
          : (req.requestSalePrice?.salePriceMax ?? ""),
      salePriceMin: req.requestSalePrice?.salePriceMin ?? "",
      rentPriceMax:
        req.requestRentPrice?.rentPriceMax === 999999999
          ? ""
          : (req.requestRentPrice?.rentPriceMax ?? ""),
      rentPriceMin: req.requestRentPrice?.rentPriceMin ?? "",

      // Superficies
      buildSurfaceMax:
        req.requestBuildSurface?.buildSurfaceMax === 999999999
          ? ""
          : (req.requestBuildSurface?.buildSurfaceMax ?? ""),
      buildSurfaceMin: req.requestBuildSurface?.buildSurfaceMin ?? "",
      plotSurfaceMax:
        req.requestPlotSurface?.plotSurfaceMax === 999999999
          ? ""
          : (req.requestPlotSurface?.plotSurfaceMax ?? ""),
      plotSurfaceMin: req.requestPlotSurface?.plotSurfaceMin ?? "",

      // Detalles
      bedroomsMax:
        req.requestBedrooms?.bedroomsMax === 999
          ? ""
          : (req.requestBedrooms?.bedroomsMax ?? ""),
      bedroomsMin: req.requestBedrooms?.bedroomsMin ?? "",
      bathroomsMax:
        req.requestBathrooms?.bathroomsMax === 999
          ? ""
          : (req.requestBathrooms?.bathroomsMax ?? ""),
      bathroomsMin: req.requestBathrooms?.bathroomsMin ?? "",

      reformed: !!req.reformed,
      toReform: !!req.toReform,
      smokeOutlet: !!req.smokeOutlet,
      profitability: !!req.profitability,
      coworking: !!req.coworking,
      exclusiveOfficeBuilding: !!req.exclusiveOfficeBuilding,
      implanted: !!req.implanted,
      seaViews: !!req.seaViews,
      golfCourseView: !!req.golfCourseView,
      fullHoursSecurity: !!req.fullHoursSecurity,
      gatedCommunity: !!req.gatedCommunity,
    };
    // IMPORTANTE: Solo recalculamos si requestById cambia (cuando llega de la API)
    // o si el ID cambia. No metas 'loader' aquí.
  }, [requestById, id, reference, user?._id, contactId]);
};
